import { useState } from "react"

import { useSelector } from "react-redux"

import ButtonComponent from "../../../../../Components/Button"
import WithdrawalsHistoryModal from "./WithdrawalsHistoryModal"

import "./WithdrawalsHistory.less"

export const WithdrawalsHistoryButton = () => {
  const { isMobile } = useSelector((state) => state.nav)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }
  return (
    <>
      <WithdrawalsHistoryModal open={isModalOpen} close={closeModal} />
      <ButtonComponent
        onClick={openModal}
        style={{ width: isMobile && "100%", height: isMobile && 40 }}
      >
        Withdrawals history
      </ButtonComponent>
    </>
  )
}

export default WithdrawalsHistoryButton
